module.exports = __webpack_public_path__ + "static/media/14.7de82fd2.svg";